import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
  },
  details: null,
  loading: false,
  activeTab: 'pnbp',
}

export const workplaceListSlice = createAppSlice({
  name: 'workplaceList',
  initialState,
  reducers: (create) => ({
    setActiveTab: create.reducer((state, { payload }) => {
      state.activeTab = payload
    }),
  }),
})

export const { setActiveTab } = workplaceListSlice.actions

export default workplaceListSlice.reducer
